export function LoginError({ error }: { error: string }) {
  return (
    <div className="mx-auto rounded-lg bg-red-200 px-5 py-3 text-red-800">
      {error}
    </div>
  );
}
